<template>
  <vx-card title="Рассылки" class="vx-card_full-height">
    <div class="data-list">
      <vs-table ref="table" class="data-list__table" pagination :max-items="40" :data="emailHistory"
                @selected="rowClicked" no-data-text="Рассылок нет">
        <template slot="thead">
          <vs-th>Дата создания</vs-th>
          <vs-th>Имя</vs-th>
          <vs-th>Месяц</vs-th>
          <vs-th>Писем на отправку</vs-th>
          <vs-th>Статус</vs-th>
          <vs-th>Автор</vs-th>
        </template>

        <template slot-scope="{data}">
          <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="whitespace-no-wrap">{{$options.filters.moment(tr.created_at, 'DD.MM.YYYY HH:mm:ss')}}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium">{{ tr.name }}</p>
            </vs-td>

            <vs-td>
              <p class="whitespace-no-wrap">{{ $options.filters.moment($parseDateFromString(tr.month), 'MMMM YYYY')
                }}</p>
            </vs-td>

            <vs-td>
              <p>{{tr.sent}}</p>
            </vs-td>

            <vs-td>
              <vs-chip v-if="tr.statistic" class="product-order-status"
                       :color="(getCampaignStatusCode(tr.statistic.campaign_status_code)).color">{{
                (getCampaignStatusCode(tr.statistic.campaign_status_code)).name }}
              </vs-chip>
            </vs-td>

            <vs-td>
              <p class="product-price">{{ tr.who ? tr.who.name : 'Не известно' }}</p>
            </vs-td>

          </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </vx-card>
</template>

<script>
  const CAMPAIGN_STATUS_CODES = [
    {id: 0, name: 'Новое задание на рассылку', color: 'warning'},
    {id: 1, name: 'Ожидается отправка (на модерации)', color: 'warning'},
    {id: 2, name: 'Отправляется', color: 'warning'},
    {id: 3, name: 'Отправлено', color: 'success'},
    {id: 4, name: 'Тестовая отправка (на имейл пользователя)', color: 'success'},
    {id: 5, name: 'Рассылка заблокирована (администрацией)', color: 'danger'},
    {id: 6, name: 'Рассылка помечена для удаления', color: 'danger'},
    {id: 7, name: 'Обновление статусов', color: 'primary'},
    {id: 8, name: 'Тестовая кампания отправлена', color: 'success'},
    {id: 9, name: 'Идет отправка', color: 'warning'},
    {id: 10, name: 'Обрабатывается, готовится к отправке', color: 'warning'},
    {id: 11, name: 'Ожидается ответ от пользователя на уточняющий вопрос модератора', color: 'warning'},
    {id: 12, name: 'Нет активных адресов', color: 'danger'},
    {id: 13, name: 'Кампания в процессе создания.', color: 'warning'},
    {id: 14, name: 'Кампания создана и отправлена в очередь для отправки.', color: 'warning'},
    {id: 15, name: 'Кампания ожидает итога A/B тестирования', color: 'warning'},
    {id: 16, name: 'Отправка кампании отменена пользователем', color: 'danger'},
    {id: 22, name: 'Отправляется частично', color: 'info'},
    {id: 23, name: 'Отправлена частично', color: 'info'},
    {id: 25, name: 'Рассылка заблокирована администрацией после частичной отправки', color: 'danger'},
    {id: 26, name: 'Черновик', color: 'danger'},
    {id: 27, name: 'Необходимо редактирование', color: 'warning'},
    {id: 28, name: 'Запланирована отправка по непрочитанным', color: 'warning'},
    {id: 33, name: 'Автосерии. Для отправки рассылки не хватило средств на балансе', color: 'danger'},
    {id: 36, name: 'Черновик автосерии', color: 'danger'}
  ];

  const EMAIL_STATUS_CODES = [
    {id: 0, name: 'В очереди на отправку', color: ''},
    {id: 1, name: 'Отправлено.', color: ''},
    {id: 2, name: 'Доставлено.', color: ''},
    {id: 3, name: 'Прочитано.', color: ''},
    {id: 4, name: 'Прочитано, квитанции просмотрены.', color: ''},
    {id: 5, name: 'Пользователь отписался от рассылки', color: ''},
    {id: 6, name: 'Адрес не существует, доставка не удалась.', color: ''},
    {id: 7, name: 'Временно недоступен', color: ''},
    {id: 8, name: 'Недоступен', color: ''},
    {id: 9, name: 'Письмо отклонено сервером как спам', color: ''},
    {id: 10, name: 'Почтовый ящик получателя переполнен', color: ''},
    {id: 11, name: 'Адресат считает письмо спамом', color: ''},
    {id: 12, name: 'Доставка не удалась по иным причинам.', color: ''},
    {id: 13, name: 'Не отправлено.', color: ''},
    {id: 14, name: 'Домен не существует.', color: ''},
    {id: 15, name: 'Отписался от рассылки.', color: ''},
    {id: 16, name: 'Отправка не удалась, email адрес невалидный', color: ''},
    {id: 17, name: 'Отправка временно запрещена', color: ''},
    {id: 18, name: 'Отключено администратором', color: ''}
  ];

  export default {
    name: "Emails",
    data() {
      return {
        CAMPAIGN_STATUS_CODES: CAMPAIGN_STATUS_CODES,
        EMAIL_STATUS_CODES: EMAIL_STATUS_CODES,
        emailHistory: [],
      }
    },
    computed: {
      selectedHouseId() {
        return this.$store.getters['appUser/selectedHouse'].id;
      },
    },
    methods: {
      getCampaignStatusCode(id = -1) {
        let status = this.CAMPAIGN_STATUS_CODES.find(status => Number(status.id) === Number(id));
        return status ? status : {name: 'Не известно'};
      },
      rowClicked(tr) {
        this.$router.push({name: 'uc_b_emails_history', params: {id: tr.id}});
      },
      async getEmailHistory() {
        let {data} = await this.$http.get('emails_history', {
          params: {
            buildings_id: this.selectedHouseId
          }
        });
        this.emailHistory = data;

        this.emailHistory.forEach(async (history) => {
          if (history.is_default) {
            let {data} = await this.$http.get('emails_history/' + history.id + '/refresh', {
              params: {
                buildings_id: this.selectedHouseId
              }
            });
            history.statistic = data;
          }
        });
      },
    },
    mounted() {
      this.getEmailHistory();
    },
    watch: {
      selectedHouseId() {
        this.getEmailHistory();
      }
    }
  }
</script>

<style lang="scss">
  .data-list {
    &__table {
      .vs-con-tbody {
        background: transparent;
        border: none;
      }

      table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        /*padding: 0 1rem;*/

        tr {
          box-shadow: 0 5px 15px 0 rgba(0, 0, 0, .05);

          td {
            padding-top: 20px !important;
            padding-bottom: 20px !important;
            border-top: 2px solid rgba(0, 0, 0, .05);
            border-bottom: 2px solid rgba(0, 0, 0, .05);

            &:first-child {
              border-left: 2px solid rgba(0, 0, 0, .05);
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }

            &:last-child {
              border-right: 2px solid rgba(0, 0, 0, .05);
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
        }

        thead {
          th {
            padding-top: 0;
            padding-bottom: 0;

            .vs-table-text {
              /*text-transform: uppercase;*/
              font-size: 1rem;
              font-weight: 600;
            }
          }

          tr {
            background: none;
            box-shadow: none;
          }
        }
      }

    }
  }
</style>